import { FormSection } from 'redux-form';
import { AddressFields } from '../../../../../../common/components/ReduxFormField';
import { required } from 'redux-form-validators';
import PostcodeList from '../../../../../../common/components/Postcode/PostcodeList';
import React from 'react';

const InsuredAddress = ({ input }) => {
  const postcode = input.value.address.postcode;
  return (
    <>
      <FormSection name={input.name}>
        <PostcodeList
          name={'address.postcode'}
          label="Postcode"
          labelSize={4}
          searchSize={2}
          postcodeFieldSize={5}
          smFieldSize={7}
          formName="PersonalAccidentForm"
          value={postcode}
          targetField={'${input.name}.address'}
          validate={required({ msg: 'postcode is required' })}
        />

        <AddressFields
          baseName={'address'}
          label="Address"
          labelSize={4}
          smFieldSize={7}
          disabled={false}
        />
      </FormSection>
    </>
  );
};

export default InsuredAddress;
